import { ActivityIndicator } from 'react-native';

export default ActivityIndicator;
